import { BadgeContainer, Container, ContentButton } from "./styles";
import Loader from "react-loader-spinner";

const ButtonOpenPreview = ({
  textColor,
  bgColor,
  text,
  fontSize,
  disabled = false,
  loading,
  icon,
  ...rest
}) => {
  const Icon = icon;
  return (
    <Container>
      <BadgeContainer
        textColor={textColor}
        bgColor={bgColor}
        fontSize={fontSize}
        disabled={disabled}
        {...rest}
      >
        {loading ? (
          <Loader type="Oval" color="white" height="16px" />
        ) : (
          <ContentButton bgColor={bgColor} textColor={textColor} fontSize={fontSize} disabled={disabled}>
            {
              icon && (<Icon color={textColor} size={18} />)
            }

            <span>{text}</span>
          </ContentButton>
        )}
      </BadgeContainer>
    </Container>
  );
};

export default ButtonOpenPreview;
